import PublicationAnalysisFigure from './PublicationAnalysisFigure';
import { getWorkshopPublicationFigures } from '../utils/publicationAnalysis';

const PublicationAnalysisWorkshopSection = ({ selectedWorkshop, diagramKey }) => {
  const figures = getWorkshopPublicationFigures(selectedWorkshop, diagramKey);

  if (!selectedWorkshop || figures.length === 0) {
    return null;
  }

  return (
    <div className="block">
      <div className="columns is-multiline">
        {figures.map(figure => (
          <div key={`${diagramKey}-${figure.landUse}`} className={figures.length > 1 ? 'column is-6' : 'column is-12'}>
            <PublicationAnalysisFigure
              title={figure.title}
              src={figure.src}
              alt={figure.alt}
              text={figure.text}
              label={figures.length > 1 ? figure.landUse : null}
              badgeText={figure.badge}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PublicationAnalysisWorkshopSection;
